module.exports = __webpack_public_path__ + "img/Sales_service_pic04.b8fbd9a0.jpeg";